export const style = {
    tabla:{
    borderTop: "outset 0.5px #c5c5c5",
    borderLeft:"solid 0.5px #c5c5c5"}
};